export const stripCountryCallingCode = (
  digits: string,
  countryCallingCode?: string,
): string => {
  if (!digits || !countryCallingCode) {
    return digits;
  }

  return digits.startsWith(countryCallingCode)
    ? digits.slice(countryCallingCode.length)
    : digits;
};
